// utils/regionCatchAll.ts
/**
 * Each country's catch-all region ("Other", "UK Other", …: `is_country_other` from fastapi) holds
 * activity located outside the country's mapped regions, such as overseas data centres (LM). It is
 * not one place, so it is not on the map (the map's caption says what it leaves out), the table
 * lists it last, and neither shows it a response rate: data-centre impressions and visits are not
 * like for like with households responding to an ad (NZ: 437 visits on 1,703 impressions, "25.7%").
 */
export const CATCH_ALL_LABEL = 'Other (outside the regions)';

export const isCatchAll = (r: { is_country_other?: boolean | null }): boolean => r.is_country_other === true;

/** The name to show: the catch-all says what it is, whatever the country calls it */
export const regionName = (r: { Region?: string; is_country_other?: boolean | null }): string =>
    isCatchAll(r) ? CATCH_ALL_LABEL : (r.Region ?? '');

/** Real regions first, in the given order; the catch-all last */
export const catchAllLast = <T extends { is_country_other?: boolean | null }>(rows: T[]): T[] => [
    ...rows.filter((r) => !isCatchAll(r)),
    ...rows.filter(isCatchAll),
];
